import React, { useContext } from "react";
import { useState, useEffect } from "react";
import {
  TextField,
  FormControl,
  FormLabel,
  FormGroup,
  MenuItem,
  Button,
  Box,
  FormHelperText,
  Grid,
  Paper,
  InputLabel,
  InputAdornment,
} from "@mui/material";

import { useToasts } from "react-toast-notifications";
import { countDecimals } from "../utils";
import { v4 as uuidv4 } from "uuid";
import { initialApplicantSource } from "../utils";
import DataContext from "../../context/DataContext";
import SelectWithValidation from "./SelectWithValidation";

import { PositionTable, PositionArchiveTable } from "./positionTables";
import AuthContext from "../../context/AuthContext";
function PositionForm() {
  let { APIData, clients, positions, update, addObj, setArchivedPositions } =
    useContext(DataContext);
  useEffect(() => {
    // console.log("useeffect in positionform");
  }, []);

  const { addToast } = useToasts();

  const defaultForm = {
    name: "",
    cost_per_hire: null,
    conversion_rate: null,
    turnover_rate: null,
    time_to_fill: null,
    avg_time_to_hire: null,
    vacancies: null,
    client: null,
    applications: null,
    interviews: null,
    assessments: null,
    hires: null,
  };
  const [positionform, setPositionform] = useState(defaultForm);
  const [positionId, setPositionId] = useState(null);

  const [applicantSource, setApplicantSource] = useState(
    initialApplicantSource
  );

  const [errorTR, setErrorTR] = React.useState(false);
  const [errorCR, setErrorCR] = React.useState(false);
  const [errorTRText, setErrorTRText] = React.useState(false);
  const [errorCRText, setErrorCRText] = React.useState(false);

  const checkTR = () => {
    let val = positionform.turnover_rate;
    if (val === null) {
      return true;
    } else if (0 <= val && val <= 1) {
      positionform.turnover_rate = Math.round(parseFloat(val) * 100) / 100;
      return true;
    } else {
      setErrorTRText("Input must be a decimal rate");
      setErrorTR(true);

      return false;
    }
  };

  const checkCR = () => {
    let val = parseFloat(positionform.conversion_rate);
    if (positionform.conversion_rate === null) {
      return true;
    } else if (0 <= val && val <= 1) {
      positionform.conversion_rate = Math.round(parseFloat(val) * 100) / 100;
      return true;
    } else {
      setErrorCRText("Input must be a decimal rate");
      setErrorCR(true);

      return false;
    }
  };

  const clearAll = () => {
    setPositionform(defaultForm);
    setPositionId(null);
    setApplicantSource(initialApplicantSource);
    setErrorTRText(null);
    setErrorTR(false);
    setErrorCRText(null);
    setErrorCR(false);
  };

  const onSubmit = async () => {
    let data = positionform;
    data["applicant_source"] = applicantSource;
    let cr = checkCR();
    let tr = checkTR();

    if (positionform.client != null && positionform.name != "")
      if (positionform.name != null)
        if (cr && tr) {
          var position = {
            ...data,
            id: Date.now(),
            date_modified: new Date().toLocaleString(),
          };
          var c = clients.filter((client) => client.id === position.client)[0];
          position["client_name"] = c.name;
          addToast("Saved Successfully", { appearance: "success" });
          addObj(position);
          // console.log(position);
          // await new Promise((r) => setTimeout(r, 500));
          clearAll();
        }
    // try {
    //   // you can test an error by deleting last slash
    //   APIData.post("/position/", data)
    //     .then((response) => {
    //       addToast("Saved Successfully", { appearance: "success" });
    //       clearAll();

    //       addObj(response.data);
    //     })
    //     .catch((error) => {
    //       addToast(error.message, { appearance: "error" });
    //       //To Do: redirect is 501
    //     });
    // } catch (error) {
    //   console.error(error);
    // }
  };

  async function onUpdate() {
    let cr = checkCR();
    let tr = checkTR();
    let data = positionform;

    if (positionform.name != null && positionform.name != "")
      if (positionform.client != null)
        if (cr && tr)
          if (positionId != null) {
            var position = {
              ...data,
              id: positionId,
              date_modified: new Date().toLocaleString(),
              client: positionform.client,
              client_name: clients.filter(
                (client) => client.id === positionform.client
              )[0].name,
            };
            update(position);

            // await new Promise((r) => setTimeout(r, 500));
            addToast("Updated Successfully", { appearance: "success" });
            clearAll();

            // APIData.patch(`/position/${positionId}/`, data)
            //   .then((response) => {
            //     addToast("Updated Successfully", { appearance: "success" });
            //     clearAll();
            //     update(response.data);
            //   })
            //   .catch((error) => {
            //     console.error(error);
            //     addToast(error.message, { appearance: "error" });
            //   });
          }
  }

  const handleIntegers = (e, keyName) => {
    let input = e.target.value;
    if (
      !input ||
      (input[input.length - 1].match("[0-9]") &&
        input[0].match("[1-9]") &&
        input.length < 7)
    )
      setPositionform({
        ...positionform,
        [keyName]: input,
      });
  };

  //check that number is less than 7 digits
  const handleApplicantSource = (e, keyName) => {
    let input = e.target.value;
    if (
      !input ||
      (input[input.length - 1].match("[0-9]") &&
        input[0].match("[1-9]") &&
        input.length < 7)
    )
      setApplicantSource({
        ...applicantSource,
        [keyName]: input,
      });
  };

  const handleRateDecimal = (e, keyName) => {
    let input = e.target.value.substr(0, 4);
    if (input.match("^(?:0(?:.[0-9]{1,2})?|1(?:.00?)?)$")) {
      setPositionform({
        ...positionform,
        [keyName]: input,
      });
      if (keyName === "turnover_rate" && errorTR === true) {
        setErrorTR(false);
        setErrorTRText(null);
      }
      if (keyName === "conversion_rate" && errorCR === true) {
        setErrorCR(false);
        setErrorCRText(null);
      }
    } else {
      if (keyName === "turnover_rate") {
        setErrorTRText("Input must be a decimal rate");
        setErrorTR(true);
      } else {
        setErrorCRText("Input must be a decimal rate");
        setErrorCR(true);
      }
    }
  };

  const handleCostPerHire = (e, keyName) => {
    var re = /^\d{0,10}(\.\d{0,2})?$/;
    let input = e.target.value;
    if (re.test(input) && input.length < 9) {
      setPositionform({
        ...positionform,
        [keyName]: input,
      });
    }
  };

  return (
    <Grid container rowSpacing={2} sx={{ width: "100%" }}>
      <Grid item>
        <Paper
          elevation={3}
          style={{
            padding: 12,
          }}
        >
          <Grid container>
            <Grid item container>
              <form onSubmit={(e) => e.preventDefault()}>
                <FormLabel></FormLabel>
                <Grid item paddingBottom={2}>
                  <Grid container display="flex" alignItems="flex-start">
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                        width: 222.67,
                      }}
                    >
                      <TextField
                        required
                        id="positionName-input"
                        // variant="outlined"
                        variant="filled"
                        name="positionName"
                        label="Position Name"
                        type="text"
                        fullWidth
                        value={positionform.name || ""}
                        onChange={(e) => {
                          setPositionform({
                            ...positionform,
                            name: e.target.value,
                          });
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                        width: 222.67,
                      }}
                    >
                      <TextField
                        id="costperhire-input"
                        variant="outlined"
                        name="costPerHire"
                        label="Cost Per Hire"
                        type="text"
                        // fullWidth
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">$</InputAdornment>
                          ),
                        }}
                        value={positionform.cost_per_hire || ""}
                        onChange={(e) => handleCostPerHire(e, "cost_per_hire")}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                      }}
                    >
                      <TextField
                        id="turnoverrate-input"
                        variant="outlined"
                        name="turnoverrate"
                        label="Turnover Rate"
                        type="number"
                        fullWidth
                        helperText={errorTRText}
                        error={errorTR}
                        value={positionform.turnover_rate || ""}
                        onChange={(e) => {
                          handleRateDecimal(e, "turnover_rate");
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                      }}
                    >
                      <TextField
                        id="conversionrate-input"
                        variant="outlined"
                        name="conversionRate"
                        label="Conversion Rate"
                        type="number"
                        fullWidth
                        helperText={errorCRText}
                        error={errorCR}
                        value={positionform.conversion_rate || ""}
                        onChange={(e) => {
                          handleRateDecimal(e, "conversion_rate");
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                      }}
                    >
                      <TextField
                        id="timtofill-input"
                        variant="outlined"
                        name="timeToFill"
                        label="Time To Fill"
                        type="text"
                        fullWidth
                        value={positionform.time_to_fill || ""}
                        onChange={(e) => {
                          handleIntegers(e, "time_to_fill");
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                      }}
                    >
                      <TextField
                        id="avgtimetohire-input"
                        variant="outlined"
                        name="avgTimeToHire"
                        label="Avg Time To Hire"
                        type="text"
                        fullWidth
                        value={positionform.avg_time_to_hire || ""}
                        onChange={(e) => {
                          handleIntegers(e, "avg_time_to_hire");
                        }}
                      />
                    </Grid>
                    <Grid
                      item
                      style={{
                        margin: "5px 5px 5px 5px",
                        // flexGrow:1
                      }}
                    >
                      <TextField
                        id="vacancies-input"
                        variant="outlined"
                        name="vacancies"
                        label="Vacancies"
                        type="text"
                        fullWidth
                        value={positionform.vacancies || ""}
                        onChange={(e) => {
                          handleIntegers(e, "vacancies");
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item paddingBottom={2}>
                  <FormGroup row>
                    <Box sx={{ borderRadius: 1 }}>
                      <FormHelperText>Funnel data</FormHelperText>
                      <TextField
                        id="applications-input"
                        variant="outlined"
                        name="applications"
                        label="applications"
                        type="text"
                        value={positionform.applications || ""}
                        onChange={(e) => {
                          handleIntegers(e, "applications");
                        }}
                        style={{
                          margin: "5px 5px 5px 5px",
                        }}
                      />

                      <TextField
                        id="interviews-input"
                        variant="outlined"
                        name="interviews"
                        label="Interviews"
                        type="text"
                        value={positionform.interviews || ""}
                        onChange={(e) => {
                          handleIntegers(e, "interviews");
                        }}
                        style={{
                          margin: "5px 5px 5px 5px",
                        }}
                      />

                      <TextField
                        id="Assessments-input"
                        variant="outlined"
                        name="Assessments"
                        label="Assessments"
                        type="text"
                        value={positionform.assessments || ""}
                        onChange={(e) => {
                          handleIntegers(e, "assessments");
                        }}
                        style={{
                          margin: "5px 5px 5px 5px",
                        }}
                      />

                      <TextField
                        id="hires-input"
                        variant="outlined"
                        name="hires"
                        label="Hires"
                        type="text"
                        value={positionform.hires || ""}
                        onChange={(e) => {
                          handleIntegers(e, "hires");
                        }}
                        style={{
                          margin: "5px 5px 5px 5px",
                        }}
                      />
                    </Box>
                  </FormGroup>
                </Grid>
                <Grid item paddingBottom={1}>
                  <FormGroup row>
                    <Box sx={{ borderRadius: 1 }}>
                      <FormHelperText>Applicant Sources</FormHelperText>
                      {Object.entries(applicantSource).map(([key, val]) => (
                        <TextField
                          key={key}
                          id={uuidv4()}
                          variant="outlined"
                          label={key}
                          type="text"
                          value={val || ""}
                          onChange={(e) => {
                            handleApplicantSource(e, [key]);
                          }}
                          style={{
                            margin: "5px 5px 5px 5px",
                          }}
                        />
                      ))}
                    </Box>
                  </FormGroup>
                </Grid>
                <Grid item>
                  <FormGroup
                    row
                    style={{
                      margin: "5px 5px 5px 5px",
                    }}
                  >
                    <Box sx={{ borderRadius: 1 }}>
                      <FormControl>
                        <InputLabel id="client-label">Client *</InputLabel>
                        <SelectWithValidation
                          required
                          style={{ width: 222.67 }}
                          labelId="client-label"
                          id="client"
                          value={positionform.client || ""}
                          variant="filled"
                          label="Client"
                          onChange={(e) => {
                            setPositionform({
                              ...positionform,
                              client: e.target.value,
                            });
                          }}
                        >
                          {clients.map((client, index) => {
                            return (
                              <MenuItem key={client.id} value={client.id}>
                                {client.name}
                              </MenuItem>
                            );
                          })}
                        </SelectWithValidation>
                        {/* {hasError && <FormHelperText>This is required!</FormHelperText>} */}
                      </FormControl>
                    </Box>
                  </FormGroup>
                </Grid>
                <FormGroup
                  row
                  style={{
                    margin: "5px 5px 5px 5px",
                    justifyContent: "center",
                  }}
                >
                  <Button
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{
                      margin: "5px 10px 10px 5px",
                    }}
                    onClick={() => onSubmit()}
                  >
                    Submit
                  </Button>
                  <Button
                    disabled={positionId == null}
                    variant="contained"
                    color="primary"
                    type="submit"
                    style={{
                      margin: "5px 10px 10px 5px",
                    }}
                    onClick={() => onUpdate()}
                  >
                    Update
                  </Button>
                </FormGroup>
              </form>
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item sx={{ width: "100%" }}>
        <Paper elevation={3}>
          <Grid>
            <Grid item>
              <PositionTable
                setApplicantSource={setApplicantSource}
                setPositionform={setPositionform}
                setPositionId={setPositionId}
                positions={positions}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  );
}

export default React.memo(PositionForm);
